// packages/agent-kit/src/hooks/admin/payments/useCreateInvoice.ts

// CORRECTED: Import names and types from the updated service.
import { adminPaymentsService, isApiError } from '@dopomogai/api-client';
import type { AdminCreateInvoicePayload, AdminCreateInvoiceResponse } from '@dopomogai/api-client';
import { AgentKitError } from '../../types'; 
import { useState, useCallback } from 'react';

export const useCreateInvoice = () => {
  const [data, setData] = useState<AdminCreateInvoiceResponse | null>(null);
  const [error, setError] = useState<AgentKitError | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const createInvoice = useCallback(async (payload: AdminCreateInvoicePayload) => {
    setIsLoading(true);
    setError(null);
    setData(null);

    // CORRECTED: Call the renamed service method.
    const res = await adminPaymentsService.createCustomInvoice(payload);

    if (isApiError(res)) {
      const err = new AgentKitError('Failed to create invoice', res);
      setError(err);
    } else {
      setData(res);
    }
    setIsLoading(false);
  }, []);

  return { createInvoice, data, error, isLoading };
};